module.exports = __webpack_public_path__ + "assets/img/th-62d180a5.png";